import { Skeleton } from '@/components/ui/skeleton';

const PLACEHOLDER_ROWS = 4;
const DAY_COUNT = 7;

/**
 * Skeleton matching the week-view grid layout (project col · 7 day cols · total col).
 * Heights are tuned to match `week-grid` cell sizes so the layout doesn't shift
 * when the real data arrives.
 */
export function WeekViewSkeleton() {
  return (
    <div
      className="grid overflow-hidden rounded-lg border bg-card shadow-sm"
      style={{ gridTemplateColumns: '280px repeat(7, minmax(0, 1fr)) 112px' }}
    >
      {/* Header */}
      <div className="flex items-center border-b bg-muted/40 px-4 py-2.5">
        <Skeleton className="h-3 w-16" />
      </div>
      {Array.from({ length: DAY_COUNT }).map((_, i) => (
        <div
          key={`head-${i}`}
          className="flex flex-col items-center gap-1 border-b border-l bg-muted/40 px-2 py-2.5"
        >
          <Skeleton className="h-3 w-8" />
          <Skeleton className="h-4 w-6" />
        </div>
      ))}
      <div className="flex items-center justify-end border-b border-l bg-muted/40 px-3 py-2.5">
        <Skeleton className="h-3 w-10" />
      </div>

      {/* Project rows */}
      {Array.from({ length: PLACEHOLDER_ROWS }).map((_, r) => (
        <div className="contents" key={`row-${r}`}>
          <div className="flex items-center gap-3 border-b px-4 py-3">
            <Skeleton className="h-7 w-7 rounded-md" />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <Skeleton className="h-3.5 w-32" />
              <Skeleton className="h-3 w-20" />
            </div>
          </div>
          {Array.from({ length: DAY_COUNT }).map((__, c) => (
            <div
              key={`cell-${r}-${c}`}
              className="flex min-h-[60px] flex-col items-center justify-center gap-1 border-b border-l"
            >
              <Skeleton className="h-3.5 w-8" />
            </div>
          ))}
          <div className="flex flex-col items-end justify-center gap-1 border-b border-l px-3 py-3">
            <Skeleton className="h-3.5 w-10" />
            <Skeleton className="h-1 w-full" />
          </div>
        </div>
      ))}

      {/* time-off strip */}
      <div className="flex items-center gap-2 border-b px-4 py-3">
        <Skeleton className="h-8 w-8 rounded-md" />
        <Skeleton className="h-3 w-24" />
      </div>
      {Array.from({ length: DAY_COUNT }).map((_, i) => (
        <div
          key={`timeoff-${i}`}
          className="flex min-h-[54px] items-center justify-center border-b border-l"
        />
      ))}
      <div className="border-b border-l" />

      {/* Totals row */}
      <div className="flex items-center bg-muted/40 px-4 py-2.5">
        <Skeleton className="h-3 w-32" />
      </div>
      {Array.from({ length: DAY_COUNT }).map((_, i) => (
        <div
          key={`tot-${i}`}
          className="flex flex-col items-center gap-1 border-l bg-muted/40 px-2 py-2.5"
        >
          <Skeleton className="h-3.5 w-8" />
          <Skeleton className="h-1 w-full" />
        </div>
      ))}
      <div className="flex flex-col items-end gap-1 border-l bg-muted/40 px-3 py-2.5">
        <Skeleton className="h-3.5 w-10" />
        <Skeleton className="h-1 w-full" />
      </div>
    </div>
  );
}
